"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const mobile_detect_1 = __importDefault(require("mobile-detect"));
const brand_1 = __importStar(require("./brand"));
const environment_1 = __importDefault(require("./environment"));
const content_1 = __importDefault(require("./content"));
const device_1 = __importDefault(require("./device"));
const brazeDevice_1 = __importDefault(require("./brazeDevice"));
const product_1 = __importStar(require("./product"));
const location_1 = __importDefault(require("./location"));
const features_1 = __importDefault(require("./features"));
const messages_1 = __importDefault(require("./messages"));
const metadata_1 = __importDefault(require("./metadata"));
const buildurl_1 = __importDefault(require("./buildurl"));
const states_1 = __importDefault(require("./states"));
const graphContext_1 = __importDefault(require("./graphContext"));
const utils_1 = require("./utils");
const OS_IOS = "iOS";
let hostname;
let userAgent;
let setProduct = "tvg4";
const getBrand = (product, hostnameParam) => {
    if (!!hostnameParam && hostnameParam.includes("racing")) {
        return brand_1.BRAND_FDR;
    }
    return product_1.PRODUCTS_FDR.includes(product) ? brand_1.BRAND_FDR : (0, brand_1.default)(hostnameParam);
};
// appConf
// appConf is set on the react native app and contains the necessary info
// to instatiate tvgConf
const tvgConf = (givenHostname = hostname, givenUserAgent = userAgent, givenProduct = setProduct) => {
    if (!givenHostname && typeof window !== "undefined" && window.location) {
        // eslint-disable-next-line
        hostname = window.location.hostname;
    }
    else {
        hostname = (0, lodash_1.get)(global, "appConf.hostname", null) || givenHostname;
    }
    if (!givenUserAgent && typeof window !== "undefined" && window.navigator) {
        // eslint-disable-next-line
        userAgent = window.navigator.userAgent;
    }
    else {
        userAgent = (0, lodash_1.get)(global, "appConf.userAgent", null) || givenUserAgent;
    }
    setProduct =
        (0, lodash_1.get)(global, "appConf.product", null) || givenProduct || setProduct;
    const uaInfo = new mobile_detect_1.default(userAgent);
    const environment = (0, lodash_1.get)(global, "appConf.environment", null) || (0, environment_1.default)(hostname);
    const product = (0, product_1.default)(setProduct);
    const device = (0, lodash_1.get)(global, "appConf.device", null) || (0, device_1.default)(userAgent, product);
    const os = product_1.PRODUCTS_IOS.includes(product)
        ? OS_IOS
        : // @ts-ignore
            uaInfo.os(userAgent);
    const features = features_1.default.readFeatures();
    const messages = messages_1.default.readMessages();
    const metadata = (0, metadata_1.default)();
    const configs = (0, content_1.default)(environment);
    const brand = getBrand(product, hostname);
    const brandConfig = configs[brand];
    const location = (0, location_1.default)(brand);
    const isRN = (0, utils_1.isRN)();
    const gaContext = `google.${product === "androidwrapper" && brand === "fdr"
        ? "fdrandroidwrapper"
        : product}`;
    const getForcedProductName = (forcedProduct) => {
        let finalProduct = forcedProduct;
        if (product_1.PRODUCTS_FDR_X_SELL.includes(forcedProduct)) {
            finalProduct = forcedProduct.replace("xsell", ""); // Forcing cast to use Product type
        }
        else if (forcedProduct === "fdrandroidgps") {
            // FDR Google play store to side-loaded
            finalProduct = "fdrandroid";
        }
        return finalProduct;
    };
    const amplitudeContext = `amplitude.${product}`;
    const brazeDevice = (0, brazeDevice_1.default)(os, product);
    return {
        brand,
        device,
        environment,
        product,
        features,
        messages,
        metadata,
        os,
        brazeDevice,
        context: (productContext = product, forceStandalone = false) => {
            const finalProduct = forceStandalone
                ? getForcedProductName(productContext)
                : product;
            return `${finalProduct}-${brand}`;
        },
        // @ts-ignore
        config: (configPath) => (0, lodash_1.get)(brandConfig, configPath, brandConfig),
        gaConfig: () => (0, lodash_1.get)(brandConfig, gaContext, brandConfig),
        amplitudeConfig: () => (0, lodash_1.get)(brandConfig, amplitudeContext, brandConfig),
        getFeatures: (localDevice = device, serverSide = false) => features_1.default.getFeatures(brandConfig.service, getForcedProductName(product), localDevice, brand, serverSide),
        getMessages: (namespaces, forceFetch = false) => messages_1.default.getMessages(namespaces, brandConfig.service.capi, getForcedProductName(product), device, brand, forceFetch),
        getStates: () => states_1.default,
        getDomains: (name = "desktop") => {
            const brandMap = Object.keys(configs);
            // @ts-ignore
            return brandMap.map((configBrand) => configs[configBrand].domain[name]);
        },
        getClientId: () => (0, utils_1.isBrowser)()
            ? btoa(`${brandConfig.clientId}:`)
            : Buffer.from(`${brandConfig.clientId}:`).toString("base64"),
        getExternalDomain: () => (0, lodash_1.get)(brandConfig, "externalDomain", {}),
        buildUrl: (options) => {
            const { app = product, wrapper = false, callback = false, path = "", params = null, relative = false } = options;
            return (0, buildurl_1.default)(app, wrapper, callback, path, params, relative)(brandConfig.domain, brand === brand_1.BRAND_FDR ? brand_1.BRAND_FDR : location, product, brazeDevice);
        },
        graphContext: () => (0, graphContext_1.default)(brand, product, device),
        isRN,
        isBrowser: utils_1.isBrowser
    };
};
exports.default = tvgConf;
// Retro-compatibility with cjs
module.exports = tvgConf;



// WEBPACK FOOTER //
// ./node_modules/@tvg/conf/cjs/src/index.js